// extracted by mini-css-extract-plugin
export default {"MainWrapper":"MainWrapper_MainWrapper__Xl8mK"};